<template>
  <ul class="saas-dashboard__usage-tooltip-list">
    <li class="saas-dashboard__usage-tooltip-list-item">
      {{ $t('common.storageUsage') }}
      <span class="saas-dashboard__usage-tooltip-list-item-value">
        <strong
          >{{ storageUsageInGB(workspaceUsage) }}{{ $t('common.gb') }}</strong
        >
        /
        <small>{{ workspaceUsage.storage_quota }}{{ $t('common.gb') }}</small>
      </span>
    </li>
    <li class="saas-dashboard__usage-tooltip-list-item">
      {{ $t('common.rowUsage') }}
      <span class="saas-dashboard__usage-tooltip-list-item-value">
        <strong>{{ workspaceUsage.row_count }}</strong> /
        <small>{{ workspaceUsage.rows_quota }}</small>
      </span>
    </li>
    <li class="saas-dashboard__usage-tooltip-list-item">
      {{ $t('common.applicationUserUsage') }}
      <span class="saas-dashboard__usage-tooltip-list-item-value">
        <strong>{{ workspaceUsage.application_users_count }}</strong> /
        <small>{{ workspaceUsage.application_users_quota }}</small>
      </span>
    </li>
    <li class="saas-dashboard__usage-tooltip-list-item">
      {{ $t('common.automationUsage') }}
      <span class="saas-dashboard__usage-tooltip-list-item-value">
        <strong>{{ workspaceUsage.automation_units_count }}</strong> /
        <small>{{ workspaceUsage.automation_units_quota }}</small>
      </span>
    </li>
  </ul>
</template>

<script>
import usage from '@saas/mixins/usage'

/**
 * The usage of a workspace compared to its quotas, shown in the tooltips of the
 * row usage on the dashboard and the all workspaces page.
 */
export default {
  name: 'WorkspaceUsageTooltipList',
  mixins: [usage],
  props: {
    workspaceUsage: {
      type: Object,
      required: true,
    },
  },
}
</script>
